module.exports = __webpack_public_path__ + "img/hello.c7e948d1.png";